// extracted by mini-css-extract-plugin
export default {"lowerContainer":"bottomButton_lowerContainer__o5WwA","lowerContainer__button":"bottomButton_lowerContainer__button__jatMv","main":"bottomButton_main__fNH7Z"};